import languageList from "../i18n/list";

export const getLanguage = (code) => {
  const language = languageList.find((language) => language.value == code);
  return language.name;
};
